/* eslint-disable react/jsx-fragments */
import React from 'react';

import { string, number, bool, shape } from 'prop-types';
import { Head } from 'nordic/head';
import { Image } from 'nordic/image';
import Iframe from '../iframe';
import IconFactory from '../icons/factory-builder';
import { DEFAULT_TOUR_CONFIG } from './constants';

const Figure = ({ className = null, url, id = null, index = null, config = DEFAULT_TOUR_CONFIG }) => {
  const parsedUrl = new URL(url);
  const baseUrl = `${parsedUrl.protocol}//${parsedUrl.hostname}`;

  return (
    <React.Fragment>
      <Head>
        <link rel="preconnect" href={baseUrl} />
      </Head>
      <Iframe
        id="iframe"
        className={className}
        loading="lazy"
        src={url}
        {...config}
        scrolling="no"
        data-index={index}
        data-testid={`image-${id}`}
      />
    </React.Fragment>
  );
};

const Icon = ({ className = null, id = 'TOUR360', color = 'BLUE' }) => (
  <div className={className}>{IconFactory({ id, color })}</div>
);

const Preview = ({ className = null, thumbnail, alt = 'Tour virtual' }) => (
  <Image className={className} lazyload="on" src={thumbnail} alt={alt} />
);

Figure.propTypes = {
  className: string,
  url: string.isRequired,
  id: string,
  index: number,
  config: shape({
    alt: string,
    title: string,
    allow: string,
    frameBorder: number,
    showSpinner: bool,
  }),
};

Icon.propTypes = {
  id: string,
  color: string,
  className: string,
};

Preview.propTypes = {
  className: string,
  thumbnail: string.isRequired,
  alt: string,
};

const FigureMemo = React.memo(Figure);

export { FigureMemo, Icon, Preview };
